import api from './api';

// Login endpoint - handled by AuthApiController
export const LOGIN_PROCESSING_URL = '/auth/j_spring_security_check';

export const authService = {
  /**
   * Authenticate user. Posts application/x-www-form-urlencoded body
   * (j_username, j_password) to the login controller endpoint.
   */
  login: async (username, password) => {
    const body = new URLSearchParams();
    body.append('j_username', username);
    body.append('j_password', password);

    const response = await api.post(LOGIN_PROCESSING_URL, body, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    return response.data;
  },

  /**
   * Get the current user session.
   */
  getSession: async () => {
    const response = await api.get('/auth/session');
    return response.data;
  },

  /**
   * Initiate MFA verification process.
   */
  initiateMfa: async () => {
    const response = await api.post('/auth/mfa/initiate');
    return response.data;
  },

  /**
   * Verify MFA code and optionally trust the device.
   */
  verifyMfa: async (code, trustDevice) => {
    const response = await api.post('/auth/mfa/verify', {
      code,
      trustDevice,
    });
    return response.data;
  },

  /**
   * Log out the current user.
   */
  logout: async () => {
    await api.post('/auth/logout');
  },

  /**
   * Get brand configuration for the current environment.
   */
  getBrand: async () => {
    const response = await api.get('/auth/brand');
    return response.data;
  },
};